export interface Article {
  id: string;
  title: string;
  category: string;
  tags: string[];
  excerpt: string;
  date: string;
  reads: string;
  time: string;
  author: string;
  image?: string;
}

export const articles: Article[] = [
  {
    id: "z-01",
    title: "反差人物身份追踪：「主角是谁」为什么比想象中更难确认",
    category: "人物追踪",
    tags: ["身份溯源", "方法论", "交叉验证"],
    excerpt:
      "一段火爆的内容走红后，「当事人到底是谁」往往成为最大的悬念。本文拆解一条身份线索从出现到被确认，通常会经历哪几个环节，以及为什么很多看似确凿的说法最后都会反转。",
    date: "2026-09-02",
    reads: "12.6w",
    time: "8分钟",
    author: "编辑部",
  },
  {
    id: "z-02",
    title: "来源追踪全记录：线索最先出现在哪里，又如何在社交网络扩散",
    category: "来源梳理",
    tags: ["首发源头", "传播路径", "舆情脉络"],
    excerpt:
      "几乎所有「反差」事件都有明确的首次曝光节点。我们把首发帖、搬运号、二次加工与热搜升温整理成一条完整时间线，帮助读者理解信息是如何一层层放大并逐渐偏离原意的。",
    date: "2026-08-29",
    reads: "9.8w",
    time: "6分钟",
    author: "编辑部",
  },
  {
    id: "z-03",
    title: "当事人身份来源追踪：私聊截图、学籍信息与「同班同学」的可信度评估",
    category: "当事人身份",
    tags: ["证据分级", "截图可信度", "侧写"],
    excerpt:
      "围绕身份的证据来源五花八门：私聊截图、证件局部、校友发声、登记信息。本文给这些证据划分可信等级，并提出「三条独立线索同时指向同一人」才宜下判断的建议。",
    date: "2026-08-26",
    reads: "8.4w",
    time: "7分钟",
    author: "观察组",
  },
  {
    id: "z-04",
    title: "从「人设落差」到「身份之谜」：主角与当事人两个概念到底差在哪",
    category: "概念辨析",
    tags: ["主角", "当事人", "涉事主体"],
    excerpt:
      "很多人把「主角」和「当事人」混为一谈。主角是被镜头呈现的那个人，当事人则可能是爆料者、被拍者与传播者的合称。厘清这些身份层次，是理性吃瓜的第一步。",
    date: "2026-08-22",
    reads: "7.1w",
    time: "5分钟",
    author: "编辑部",
  },
  {
    id: "z-05",
    title: "一次典型反差事件的完整时间轴：从首发到定性的 72 小时",
    category: "事件复盘",
    tags: ["时间轴", "复盘", "舆情走向"],
    excerpt:
      "我们以一组合成事件样本为例，把发酵过程拆成首发、扩散、站队、质疑、求证、降温六个阶段，说明情绪如何先于事实抵达，也提醒旁观者何时应该按下暂停键。",
    date: "2026-08-18",
    reads: "10.2w",
    time: "9分钟",
    author: "研究组",
  },
  {
    id: "z-06",
    title: "关系网络图谱：当事人、爆料者、搬运号与「同款素人」之间如何相连",
    category: "人物关系",
    tags: ["关系图", "搬运链条", "同款炒作"],
    excerpt:
      "每一个走红的主角背后都牵扯着一张关系网。本文用文字图谱说明当事人与爆料者、MCN、模仿者之间常见的连接方式，帮助读者识别哪些讨论是真争议、哪些只是流量生意。",
    date: "2026-08-14",
    reads: "6.3w",
    time: "6分钟",
    author: "观察组",
  },
  {
    id: "z-07",
    title: "同款账号与高仿炒作：如何分辨「同一人」还是「蹭热度」",
    category: "身份核验",
    tags: ["同款", "高仿", "冒名"],
    excerpt:
      "热点之下总是冒出大量自称「当事人」的账号。本文给出五条可操作的鉴别方法：看注册时间、看历史内容、看认证主体、看互动对象、看信息互斥点，帮你快速排除冒牌货。",
    date: "2026-08-10",
    reads: "5.9w",
    time: "5分钟",
    author: "编辑部",
  },
  {
    id: "z-08",
    title: "为什么「眼见为实」在身份问题上往往不成立：认知偏误盘点",
    category: "心理视角",
    tags: ["认知偏误", "先入为主", "群体极化"],
    excerpt:
      "一旦我们提前站队，之后看到的每一条新证据都会被自动代入预设剧情。本文盘点确认偏误、聚光灯效应与群体极化在「追查身份」过程中的典型表现，以及如何主动规避。",
    date: "2026-08-06",
    reads: "4.8w",
    time: "6分钟",
    author: "研究组",
  },
];